import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface NotionAhjInputProps {
  onNotionAhjChange: (value: string) => void;
  notionAhjValue: string;
  isEnabled: boolean;
}

export const NotionAhjInput: React.FC<NotionAhjInputProps> = ({
  onNotionAhjChange,
  notionAhjValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="NOTION (AHJ)"
      label="Enter NOTION (AHJ) link:"
      placeholder="https://notion.so/..."
      value={notionAhjValue}
      onChange={onNotionAhjChange}
      isEnabled={isEnabled}
    />
  );
};